var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-center text-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticStyle:{"margin":"0 auto","position":"relative"}},[_c('div',{staticClass:"col-md-10",staticStyle:{"margin":"0 auto","position":"relative"}},[_c('PieChart',{staticStyle:{"width":"100%"},attrs:{"data":this.chartdata,"url":''}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }